/* Holiday Particle Effects – spawns CSS-animated particles inside any
   element that carries a data-holiday="<theme>" attribute.

   Themes: christmas | halloween | valentines | st_patricks |
           easter | fourth_of_july | thanksgiving
*/
(function () {
  'use strict';

  var THEMES = {
    christmas: {
      symbols:    ['❄', '❅', '❆', '✦', '✧'],
      colors:     ['#ffffff', '#e8f4fd', '#b3d9ff', '#cce5ff'],
      maxParticles: 50,
      spawnMin: 150, spawnMax: 500,
      sizeMin: 10,  sizeMax: 24,
      speedMin: 4,  speedMax: 10,
      opacityMin: 0.4, opacityMax: 0.9,
      driftMin: -30, driftMax: 30,
    },
    halloween: {
      symbols:    ['🦇', '🕷', '🌙', '✦', '◆'],
      colors:     ['#ff6600', '#9900cc', '#ff9900', '#cc44ff', '#ff4400'],
      maxParticles: 20,
      spawnMin: 400, spawnMax: 1000,
      sizeMin: 14,  sizeMax: 28,
      speedMin: 3,  speedMax: 8,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -20, driftMax: 20,
    },
    valentines: {
      symbols:    ['❤', '♥', '✿', '❧', '♡'],
      colors:     ['#ff1744', '#ff6b9d', '#ff80ab', '#f48fb1', '#ff4081'],
      maxParticles: 30,
      spawnMin: 250, spawnMax: 700,
      sizeMin: 12,  sizeMax: 24,
      speedMin: 4,  speedMax: 9,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -25, driftMax: 25,
    },
    st_patricks: {
      symbols:    ['☘', '✦', '⬡', '✿', '⋆'],
      colors:     ['#00a651', '#4caf50', '#1b5e20', '#81c784', '#00c853'],
      maxParticles: 30,
      spawnMin: 250, spawnMax: 700,
      sizeMin: 12,  sizeMax: 24,
      speedMin: 4,  speedMax: 9,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -25, driftMax: 25,
    },
    easter: {
      symbols:    ['🌸', '🌷', '🥚', '✿', '⚘', '✦'],
      colors:     ['#ff80ab', '#b39ddb', '#80deea', '#a5d6a7', '#fff176', '#ce93d8'],
      maxParticles: 25,
      spawnMin: 300, spawnMax: 800,
      sizeMin: 12,  sizeMax: 24,
      speedMin: 4,  speedMax: 9,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -25, driftMax: 25,
    },
    fourth_of_july: {
      symbols:    ['★', '✦', '⋆', '✧', '✩'],
      colors:     ['#ff0000', '#ffffff', '#0033cc', '#ff6666', '#6699ff'],
      maxParticles: 45,
      spawnMin: 150, spawnMax: 500,
      sizeMin: 10,  sizeMax: 24,
      speedMin: 3,  speedMax: 8,
      opacityMin: 0.4, opacityMax: 1,
      driftMin: -20, driftMax: 20,
    },
    thanksgiving: {
      symbols:    ['🍁', '🍂', '🍃', '✦', '❧'],
      colors:     ['#bf360c', '#e65100', '#f9a825', '#558b2f', '#795548', '#ff6d00'],
      maxParticles: 30,
      spawnMin: 250, spawnMax: 700,
      sizeMin: 12,  sizeMax: 26,
      speedMin: 3,  speedMax: 7,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -30, driftMax: 30,
    },
    top_mobility: {
      symbols:    ['👩‍🦼', '🧑‍🦽', '🛵', '💺', '⚪️', '🔵', '🔴'],
      colors:     ['#0057a8', '#ffffff', '#f0b429', '#003f7d', '#6db3f2'],
      maxParticles: 20,
      spawnMin: 500, spawnMax: 1200,
      sizeMin: 16,  sizeMax: 30,
      speedMin: 4,  speedMax: 9,
      opacityMin: 0.5, opacityMax: 1,
      driftMin: -20, driftMax: 20,
    },
  };

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function pick(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
  }

  function spawnParticle(container, cfg) {
    var el = document.createElement('span');
    el.className = 'holiday-fx-particle';
    el.textContent = pick(cfg.symbols);
    el.setAttribute('aria-hidden', 'true');

    var size  = rand(cfg.sizeMin,    cfg.sizeMax);
    var dur   = rand(cfg.speedMin,   cfg.speedMax);
    var op    = rand(cfg.opacityMin, cfg.opacityMax);
    var left  = rand(0, 100);
    var drift = rand(cfg.driftMin,   cfg.driftMax);
    var rot   = rand(-360, 360);
    var color = pick(cfg.colors);

    el.style.cssText =
      'left:'           + left  + '%;'   +
      'font-size:'      + size  + 'px;'  +
      'color:'          + color + ';'    +
      '--hfx-dur:'      + dur   + 's;'   +
      '--hfx-opacity:'  + op    + ';'    +
      '--hfx-drift:'    + drift + 'px;'  +
      '--hfx-rotate:'   + rot   + 'deg;';

    container.appendChild(el);

    el.addEventListener('animationend', function () {
      el.remove();
    }, { once: true });
  }

  function startEffect(host, themeName) {
    var cfg = THEMES[themeName];
    if (!cfg) return;

    var container = document.createElement('div');
    container.className = 'holiday-fx-container';
    container.setAttribute('aria-hidden', 'true');
    host.appendChild(container);

    function schedule() {
      if (!container.isConnected) return;
      if (container.children.length < cfg.maxParticles) {
        spawnParticle(container, cfg);
      }
      setTimeout(schedule, rand(cfg.spawnMin, cfg.spawnMax));
    }

    schedule();
  }

  function init() {
    document.querySelectorAll('[data-holiday]').forEach(function (el) {
      startEffect(el, el.dataset.holiday);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
